import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import AdminGroupsListHeader from './ListHeader';
import AdminGroupsListItem from './ListItem';

const AdminGroupsList = ({
  groups,
  handleDelete,
  ...props
}) => (
  <div className="table-wrapper">
    <Table className="users-list groups-list" responsive>
      <thead>
        <AdminGroupsListHeader
          {...props}
        />
      </thead>
      <tbody>
        {groups.map(group => (
          <AdminGroupsListItem
            key={group.uuid}
            group={group}
            handleDelete={handleDelete}
          />
        ))}
      </tbody>
    </Table>
  </div>
);

AdminGroupsList.propTypes = {
  groups: PropTypes.array.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default AdminGroupsList;
